<p-toast position="top-right"></p-toast>

<div class="notification-info-container">
  <!-- Header Section -->
  <div class="notification-profile-header">
    <h2>{{ 'NOTIFICATION_PAGE.NOTIFICATION_HEADING' | translate }}</h2>
    <div class="btn-section">
      <a href="#/notification/notifications-history">
        <button
          pButton
          label="{{ 'NOTIFICATION_PAGE.BUTTON_LABELS.VIEW_HISTORY' | translate }}"
          class="p-button-primary"
        ></button>
      </a>
    </div>
  </div>

  <div
    class="main-content"
    [ngClass]="{ 'collapsed-content': sidebarCollapsed, 'expanded-content': !sidebarCollapsed }"
  >
    <div class="notification-input-container">
      <div class="notification-details">
        <label for="notificationTitle"
          >{{ 'NOTIFICATION_PAGE.NOTIFICATION_FORM_FIELDS.NOTIFICATION_TITLE' | translate }}
          <small class="char-count">{{ notificationPayload.title.length }}/50</small>
        </label>
        <input
          id="notificationTitle"
          type="text"
          maxlength="50"
          (input)="updateCharacterCount()"
          pInputText
          [(ngModel)]="notificationPayload.title"
        />
      </div>

      <div class="notification-details">
        <label for="notificationMessage" class="notification-label">
          {{ 'NOTIFICATION_PAGE.NOTIFICATION_FORM_FIELDS.NOTIFICATION_MESSAGE' | translate }}
          <small class="char-count">{{ notificationPayload.message.length }}/240</small>
        </label>
        <div class="emoji-div">
          <i class="pi pi-face-smile emoji-icon" (click)="showEmojiPicker = !showEmojiPicker"></i>
          <div *ngIf="showEmojiPicker" class="emoji-picker">
            <emoji-mart
              set="apple"
              (emojiClick)="addEmoji($event)"
              class="emoji-mart-wrapper"
              [emojiTooltip]="true"
              [perLine]="8"
              [emojiSize]="24"
            >
            </emoji-mart>
          </div>
        </div>
        <textarea
          id="notificationMessage"
          rows="3"
          cols="130"
          maxlength="240"
          pInputTextarea
          (input)="updateCharacterCount()"
          [(ngModel)]="notificationPayload.message"
          (click)="showEmojiPicker = false"
        ></textarea>
      </div>
    </div>

    <div class="btn-section">
      <div class="tc-notification-section">
        <div class="tc-inline-container">
          <p-checkbox
            inputId="notifyUpdatedTC"
            [(ngModel)]="notificationPayload.hasTermsAndConditionsVersionRelease"
            binary="true"
            label="{{ 'NOTIFICATION_PAGE.NOTIFICATION_FORM_FIELDS.NOTIFY_UPDATED_TC' | translate }}"
          ></p-checkbox>
          <input
            *ngIf="notificationPayload.hasTermsAndConditionsVersionRelease"
            id="tcVersion"
            type="text"
            pInputText
            [(ngModel)]="notificationPayload.termsAndConditionsVersion"
            (input)="onVersionInput($event)"
            placeholder="{{
              'NOTIFICATION_PAGE.NOTIFICATION_FORM_FIELDS.TC_VERSION_PLACEHOLDER' | translate
            }}"
            class="txt-version-field"
          />
        </div>
      </div>
      <button
        pButton
        label="{{ 'NOTIFICATION_PAGE.BUTTON_LABELS.SEND_NOTIFICATION' | translate }}"
        icon="pi pi-bell"
        class="p-button-primary"
        (click)="onSendNotification()"
      ></button>
    </div>
  </div>

  <div class="recipients-container">
    <div class="recipients-header">
      <div class="notification-profile-header">
        <h2>{{ 'NOTIFICATION_PAGE.NOTIFICATION_RECIPIENTS' | translate }}</h2>
      </div>

      <div class="p-field send-to">
        <label>{{ 'NOTIFICATION_PAGE.NOTIFICATION_FORM_FIELDS.SEND_TO' | translate }}</label>
        <div class="checkbox-container">
          <p-checkbox
            inputId="callers"
            [(ngModel)]="notificationPayload.sendToCallers"
            (ngModelChange)="onSendToChange()"
            binary="true"
            label="{{ 'NOTIFICATION_PAGE.RADIO_LABELS.CALLERS' | translate }}"
          ></p-checkbox>
          <p-checkbox
            inputId="talkingBuddy"
            [(ngModel)]="notificationPayload.sendToTalkingBuddies"
            (ngModelChange)="onSendToChange()"
            binary="true"
            label="{{ 'NOTIFICATION_PAGE.RADIO_LABELS.TB' | translate }}"
          ></p-checkbox>
        </div>
      </div>
    </div>
    <div class="recipients-filters">
      <div class="search-filters">
        <div class="filter-item">
          <label for="username" class="filter-label">{{
            'NOTIFICATION_PAGE.FILTER_LABELS.NAME' | translate
          }}</label>
          <input
            type="text"
            pInputText
            placeholder="{{ 'NOTIFICATION_PAGE.PLACEHOLDERS.ENTER_USER_NAME' | translate }}"
            class="filter-field"
            id="username"
            [(ngModel)]="filters.firstName"
            (input)="onFilterChange(activeFilter)"
          />
        </div>
        <div class="filter-item">
          <label for="mobileNumber" class="filter-label">{{
            'NOTIFICATION_PAGE.FILTER_LABELS.MOBILE_NUMBER' | translate
          }}</label>
          <input
            type="text"
            pInputText
            placeholder="{{ 'NOTIFICATION_PAGE.PLACEHOLDERS.ENTER_MOBILE_NUMBER' | translate }}"
            class="filter-field"
            id="mobileNumber"
            [(ngModel)]="filters.phoneNumber"
            (input)="onFilterChange(activeFilter)"
          />
        </div>
        <div class="filter-item">
          <label for="countryId" class="filter-label">{{
            'NOTIFICATION_PAGE.FILTER_LABELS.COUNTRY' | translate
          }}</label>
          <p-dropdown
            [options]="countryIds"
            [(ngModel)]="filters.countryId"
            id="id"
            optionLabel="countryName"
            placeholder="{{ 'NOTIFICATION_PAGE.PLACEHOLDERS.SELECT_COUNTRY' | translate }}"
            (ngModelChange)="onFilterChange('country')"
            styleClass="filter-ddl"
          ></p-dropdown>
        </div>
        <div class="filter-item">
          <label for="regionId" class="filter-label">{{
            'NOTIFICATION_PAGE.FILTER_LABELS.STATE' | translate
          }}</label>
          <p-dropdown
            [options]="regionIds"
            [(ngModel)]="filters.regionId"
            id="regionId"
            optionLabel="regionName"
            placeholder="{{ 'NOTIFICATION_PAGE.PLACEHOLDERS.SELECT_STATE' | translate }}"
            styleClass="filter-ddl"
            (ngModelChange)="onFilterChange(activeFilter)"
          ></p-dropdown>
        </div>
        <div class="filter-item">
          <label for="fromToDate" class="filter-label">{{
            'NOTIFICATION_PAGE.FILTER_LABELS.FROM_TO_DATE' | translate
          }}</label>
          <p-calendar
            id="fromToDate"
            [(ngModel)]="filters.dateRange"
            selectionMode="range"
            [showButtonBar]="true"
            [readonlyInput]="true"
            placeholder="{{ 'NOTIFICATION_PAGE.PLACEHOLDERS.SELECT_DATE_RANGE' | translate }}"
            dateFormat="dd-M-yy"
            (ngModelChange)="onFilterChange(activeFilter)"
          >
          </p-calendar>
        </div>
        <div class="filter-item">
          <label for="paymentProfile" class="filter-label">{{
            'NOTIFICATION_PAGE.FILTER_LABELS.PAYMENT_PROFILE' | translate
          }}</label>
          <p-dropdown
            [options]="paymentProfileFilterOptions"
            [(ngModel)]="filters.paymentProfile"
            id="paymentProfile"
            optionLabel="label"
            optionValue="value"
            placeholder="{{ 'NOTIFICATION_PAGE.PLACEHOLDERS.SELECT_PAYMENT_PROFILE' | translate }}"
            styleClass="filter-ddl"
            (ngModelChange)="onFilterChange(activeFilter)"
          ></p-dropdown>
        </div>
        <div class="filter-item">
          <label for="userStatus" class="filter-label">{{
            'NOTIFICATION_PAGE.FILTER_LABELS.USER_STATUS' | translate
          }}</label>
          <p-dropdown
            [options]="userStatusFilterOptions"
            [(ngModel)]="filters.userStatus"
            id="userStatus"
            optionLabel="label"
            optionValue="value"
            placeholder="{{ 'NOTIFICATION_PAGE.PLACEHOLDERS.SELECT_STATUS' | translate }}"
            styleClass="filter-ddl"
            (ngModelChange)="onFilterChange(activeFilter)"
          ></p-dropdown>
        </div>
        <div class="filter-item">
          <a class="reset-link" (click)="onResetFilters()">{{
            'NOTIFICATION_PAGE.BUTTONS.RESET' | translate
          }}</a>
        </div>
      </div>
    </div>
    <div class="recipients-list">
      <p-table
        [value]="recipientItems.length !== 0 ? recipientItems : noDataRow"
        [paginator]="recipientItems.length !== 0 ? true : false"
        [rows]="recipientRows"
        [first]="recipientFirst"
        [totalRecords]="recipientTotalRecords"
        [lazy]="true"
        (onPage)="recipientPageChange($event)"
        (onSort)="recipientSortChange($event)"
        [rowsPerPageOptions]="tableParams.ROW_PER_PAGE"
        [sortField]="sortField"
        [sortOrder]="sortOrder === 'asc' ? 1 : -1"
        [(selection)]="selectedRecipients"
      >
        <ng-template pTemplate="header">
          <tr>
            <th class="checkbox-container-column">
              <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
            </th>
            <th pSortableColumn="FirstName">
              {{ 'NOTIFICATION_PAGE.USERS_TABLE.NAME' | translate
              }}<p-sortIcon field="FirstName"></p-sortIcon>
            </th>
            <th pSortableColumn="PhoneNumber">
              {{ 'NOTIFICATION_PAGE.USERS_TABLE.MOBILE_NUMBER' | translate
              }}<p-sortIcon field="PhoneNumber"></p-sortIcon>
            </th>
            <th pSortableColumn="Email">
              {{ 'NOTIFICATION_PAGE.USERS_TABLE.EMAIL_ADDRESS' | translate
              }}<p-sortIcon field="Email"></p-sortIcon>
            </th>
            <th pSortableColumn="CreatedOn">
              {{ 'NOTIFICATION_PAGE.USERS_TABLE.CREATED_ON' | translate
              }}<p-sortIcon field="CreatedOn"></p-sortIcon>
            </th>
            <th *ngIf="activeFilter === userTypeConstants.TALKING_BUDDY">
              {{ 'NOTIFICATION_PAGE.USERS_TABLE.PAYMENT_PROFILE' | translate }}
            </th>
            <th>
              {{ 'NOTIFICATION_PAGE.USERS_TABLE.STATUS' | translate }}
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-user>
          <tr *ngIf="recipientItems?.length !== 0" class="user-row">
            <td class="checkbox-container-column">
              <p-tableCheckbox [value]="user"></p-tableCheckbox>
            </td>
            <td>{{ formatFullName(user) }}</td>
            <td>{{ user.phoneNumber }}</td>
            <td>{{ user.email }}</td>
            <td>
              {{
                user?.createdOn
                  ? (getConvertedDate(user.createdOn || '') | date: 'dd-MMM-YYYY')
                  : ''
              }}
            </td>
            <td *ngIf="activeFilter === userTypeConstants.TALKING_BUDDY">
              {{ user.accountKycStatus }}
            </td>
            <td (click)="$event.stopPropagation()">
              <button
                pButton
                size="small"
                [label]="
                  user.isBlocked
                    ? ('NOTIFICATION_PAGE.USERS_TABLE.BLOCKED' | translate)
                    : ('NOTIFICATION_PAGE.USERS_TABLE.ACTIVE' | translate)
                "
                [class]="user.isBlocked ? 'p-button-danger' : 'p-button-secondary'"
                class="action-button"
              ></button>
            </td>
          </tr>
          <tr *ngIf="recipientItems?.length === 0">
            <td colspan="6" class="no-data-available">{{ 'COMMON.NO_AVAILABLE' | translate }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
